import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";

export async function getLoyaltyDetails(isAuthenticated) {
  try {
    const loyaltySdk = await sdkInstanceProvider("loyalty");
    const { getCustomerTierId, getCustomerDetails } = loyaltySdk;
    const isLoyaltyAvailable = await loyaltySdk.isLoyaltyAvailable();

    if (!isAuthenticated) {
      return {
        consentStatus: null,
        customerTierId: null,
        isLoyaltyAvailable,
        loyaltySdk
      };
    }

    const customerTierId = await getCustomerTierId();
    const { consentStatus } = await getCustomerDetails();

    return {
      consentStatus,
      customerTierId,
      isLoyaltyAvailable,
      loyaltySdk
    };
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      noticeError(error);
    }

    return {
      consentStatus: null,
      customerTierId: null,
      isLoyaltyAvailable: false,
      loyaltySdk: null
    };
  }
}
